/**
 * image-frame.ts — client-side image orientation check for report photos.
 *
 * Panel cards must stay uniform, so the photo panel only accepts horizontal
 * (landscape) images. `isPortrait` is used both to reject a vertical photo on
 * pick/capture and to flag any vertical that renders in a slot.
 */

/** Loads a File/Blob into an HTMLImageElement (revokes its object URL after). */
export function loadImage(file: Blob): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("No se pudo leer la imagen."));
    };
    img.src = url;
  });
}

/** True when the image is taller than it is wide (portrait). */
export async function isPortrait(file: Blob): Promise<boolean> {
  const img = await loadImage(file);
  return img.naturalHeight > img.naturalWidth;
}
